import setStateFromSearchParameter from './set-state-from-search-parameter';
import setStateFromPath from './set-state-from-path';

const setStateFromHistory = (history, config) => dispatch => {
  dispatch(setStateFromSearchParameter(history));
  dispatch(setStateFromPath(history, config));
};

export default setStateFromHistory;
